import * as Yup from "yup";

export const transferSchema = (intl) => {
  return Yup.object().shape({
    amount: Yup.string()
      .nullable(false)
      .required(intl.formatMessage({ id: "amountRequired" })),
    username: Yup.string()
      .nullable(false)
      .required(intl.formatMessage({ id: "usernameRequired" })),
  });
};
